import { render, staticRenderFns } from "./planArchive.vue?vue&type=template&id=38184c93&scoped=true&"
import script from "./planArchive.vue?vue&type=script&lang=js&"
export * from "./planArchive.vue?vue&type=script&lang=js&"
import style0 from "./planArchive.vue?vue&type=style&index=0&id=38184c93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38184c93",
  null
  
)

export default component.exports